import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const LifespanIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 290.07 290.07" width={props.height} height={props.height} >
		<path d="M54.922,0
	c-2.759,0.042-4.963,2.311-4.924,5.07v280c0,2.761,2.239,5,5,5l180.821-0.062c2.125-0.286,4.06-1.783,4.234-4.514L240.073,5
	c0-2.761-2.239-5-5-5h-180v0.01c-0.05,0-0.1-0.01-0.148-0.01L54.922,0z M59.998,10h170.073v270.07H59.998V10z M94.998,20.07
	c-2.761,0-4.999,2.239-5,5v10c0,2.761,2.239,5,5,5h100c2.762,0,5-2.239,5-5v-10c0-2.761-2.238-5-5-5H94.998z M94.998,50.07
	c-2.761,0-4.999,2.239-5,5v10c0,2.761,2.239,5,5,5h100c2.762,0,5-2.239,5-5v-10c0-2.761-2.238-5-5-5H94.998z M94.998,100.07
	c-6.761-0.096-6.761,10.096,0,10h100c6.762,0.096,6.762-10.096,0-10H94.998z M94.998,120.07c-6.761-0.096-6.761,10.096,0,10h100
	c6.762,0.096,6.762-10.096,0-10H94.998z M94.998,140.07c-6.761-0.096-6.761,10.096,0,10h100c6.762,0.096,6.762-10.096,0-10H94.998z
	 M144.998,180.07c-13.748,0-25,11.252-25,25c0,3.573,0.767,6.975,2.133,10.057l-11.91,38.465c-1.243,4.018,2.727,7.682,6.633,6.121
	l8.144-3.256l8.143,3.256c2.902,1.161,6.146-0.597,6.76-3.662l5.095-25.48l5.098,25.48c0.769,3.999,4.705,4.831,7.387,3.412
	l7.517-3.006l7.033,2.812c3.405,2.526,9.499-0.526,7.723-5.738l-12.203-37.709c1.567-3.262,2.447-6.909,2.447-10.752
	C169.998,191.322,158.746,180.07,144.998,180.07L144.998,180.07z M144.998,190.07c8.344,0,15,6.656,15,15s-6.656,15-15,15
	c-8.343,0-15-6.656-15-15S136.655,190.07,144.998,190.07z M129.625,224.738c1.725,1.353,3.628,2.492,5.67,3.359l-4.021,20.098
	l-4.42-1.768c-1.192-0.477-2.521-0.477-3.713,0l-0.266,0.106L129.625,224.738z M160.018,225.018l6.941,21.453l-0.105-0.043
	c-0.621-0.248-1.285-0.369-1.953-0.356c-0.604,0.011-1.2,0.132-1.76,0.356l-4.42,1.768l-4.02-20.096
	C156.605,227.291,158.387,226.25,160.018,225.018L160.018,225.018z"/>


	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Lifespan.tsx